module.exports = __webpack_public_path__ + "img/satellite-empty-state.709071cb.svg";